import css from 'styled-jsx/css';

const styles = css.global`.text-headline {
  color: #222222;
  font-family: 'SantanderHeadline';
  font-size: 24px;
  letter-spacing: 0;
  line-height: 36px;
  margin: 16px 0;
  font-weight: 400;
}

@media (min-width: 992px) {
  .text-headline {
    color: #222222;
    font-family: 'Open Sans';
    font-size: 32px;
    letter-spacing: 0;
    line-height: 43px;
  }
}
`;

export default styles;